import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { FiltroConsultarResultadoAvaliacaoInstitucionalComponent } from '../filtro-consultar-resultado-avaliacao-institucional/filtro-consultar-resultado-avaliacao-institucional.component';
import { ResultadoAvaliacaoInstitucionalComponent } from '../resultado-avaliacao-institucional/resultado-avaliacao-institucional.component';
import { ResultadoAvaliacaoInstitucionalService } from '../services/resultado-avaliacao-institucional.service';

@Component({
	standalone: true,
	imports: [FiltroConsultarResultadoAvaliacaoInstitucionalComponent, ResultadoAvaliacaoInstitucionalComponent],
	templateUrl: './consultar-resultado-avaliacao-institucional.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConsultarResultadoAvaliacaoInstitucionalComponent implements OnInit {
	private readonly resultadoAvaliacao = inject(ResultadoAvaliacaoInstitucionalService);

	ngOnInit() {
		this.resultadoAvaliacao.listarOrgaos();
	}
}
